import DateRangeWithShortcuts from '@/components/DateRangeWithShortcuts';
import RadioSwitch from '@/components/RadioSwitch';
import { USAGE_INTENT_OPTIONS } from '@/constants/firstPartyData';
import { getFieldErrorProps } from '@/helpers/form';
import { FILE_NAME_RULES } from '@/utils/validationRules';
import { Autocomplete, Button, FormHelperText, InputLabel, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';

const FileInfo = ({ errorDateText, setErrorDateText }) => {
  const { advertiserList } = useSelector(state => state.firstPartyData);
  const { control } = useFormContext();

  return (
    <>
      <div className='flex-1 pb-4'>
        <InputLabel htmlFor='name'>Name</InputLabel>
        <Controller
          name='name'
          control={control}
          rules={FILE_NAME_RULES}
          render={({ field, fieldState }) => (
            <TextField {...field} fullWidth placeholder='File name' id='name' {...getFieldErrorProps(fieldState)} />
          )}
        />
      </div>
      <div className='flex-1 pb-4'>
        <InputLabel id='advertiser-select-label'>Advertiser</InputLabel>
        <Controller
          name='advertiser'
          rules={{ required: { value: true, message: 'Advertiser is required' } }}
          control={control}
          render={({ field, fieldState }) => (
            <Autocomplete
              {...field}
              renderInput={props => (
                <TextField
                  {...props}
                  sx={{
                    '& .MuiInputBase-input': {
                      fontWeight: '400',
                    },
                  }}
                  placeholder='Select Advertiser'
                  {...getFieldErrorProps(fieldState)}
                />
              )}
              getOptionLabel={option => option.label}
              isOptionEqualToValue={(option, value) => option.value === value.value}
              onChange={(_, value) => field.onChange(value)}
              options={advertiserList}
            />
          )}
        />
      </div>
      <div className='flex-1 pb-4'>
        <InputLabel id='data-range'>Date Range of Data</InputLabel>
        <Controller
          name='dateRange'
          control={control}
          defaultValue={[null, null]}
          render={({ field: { onChange, value } }) => (
            <DateRangeWithShortcuts
              value={value}
              onChange={newDates => {
                setErrorDateText(null);
                onChange(newDates);
              }}
              placeholder='Select Date Range'
              height={48}
              errorText={errorDateText}
            />
          )}
        />
        {!!errorDateText && (
          <FormHelperText error id='date-range-error'>
            {errorDateText}
          </FormHelperText>
        )}
      </div>
      <div className='pb-4'>
        <InputLabel id='usage-intent'>Usage Intent</InputLabel>
        <Controller
          name='usageIntent'
          control={control}
          render={({ field: { onChange, value } }) => (
            <div className='flex'>
              <RadioSwitch value={value} onChange={onChange} options={USAGE_INTENT_OPTIONS} />
            </div>
          )}
        />
      </div>
      <div className='flex-1 flex-col pb-2'>
        <div className='text-sm pb-2 font-semibold'>
          Download File to Use for Upload <span className='text-sm'>(Please only use this format)</span>
        </div>
        <a href='./sample_file.csv' download='sample_file.csv'>
          <Button variant='contained'>sample_file.csv</Button>
        </a>
      </div>
    </>
  );
};

FileInfo.propTypes = {
  errorDateText: PropTypes.string,
  setErrorDateText: PropTypes.func,
};

export default FileInfo;
